<template>
  <div>
    <!-- <div class="accessIndex__reload--container"
      @click="previousSelection()">
      <i class="material-icons" style="color: #009CDE">keyboard_backspace</i>
    </div> -->
    <div class="structure_date">
      <div class="structure_date__date">
          <p>Selecciona la hora</p>
      </div>
    </div>
    <div class="time_select">
      <div 
      v-for="(hour,index) in schedules" :key="index"
      :class="hour.click===true ? 'time_select__item_select':'time_select__item'">
        <div :class="hour.click===true ? 'time_select__item_select--begin':'time_select__item--begin'">
          <p>Ingreso</p>
          <div>
              <img src="@/assets/img/sportlife/flecha-entrada-verde.svg" alt="">
              <span>{{ convertHourToStyleFormat(hour.beginning) }}</span>
          </div>
        </div>
        <div :class="hour.click===true ? 'time_select__item_select--end':'time_select__item--end'">
          <p>Salida</p>
          <div>
              <img src="@/assets/img/sportlife/flecha-salida-roja.svg" alt="">
              <span>{{ convertHourToStyleFormat(hour.ending) }}</span>
          </div>
        </div>
        <div :class="hour.click===true ? 'time_select__item_select--session':'time_select__item--session'">
          <p>Sesión</p>
          <div>
          <img src="@/assets/img/sportlife/icono-fecha.svg" alt="">
          <span>{{ convertTimeToString(sublocationTime) }}</span>
          </div>
        </div>
        <div :class="hour.click===true ? 'time_select__item_select--session':'time_select__item--session'">
          <p>Cupos disponibles</p>
          <div>
          <img src="@/assets/img/sportlife/icono-user.svg" alt="">
          <span>{{ sublocationSpaces- hour.bookings }}</span>
          </div>
        </div>
        <button @click.stop="clickBooking(hour.beginning, hour.ending, index)"
          :class="hour.click===true ? 'time_select__item_select--button':'time_select__item--button'">
          Agendar horario
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                schedules:[],
                days:["sunday","monday","tuesday","wednesday", "thursday", "friday", "saturday"],
                sublocationTime:"0:00",
                sublocationSpaces:0,
                time_zone: '',
                country: '',
                gtm: '',
                location_time_zone: '',
            }
        },
        props:["date", "sublocation"],
        methods: {    
            requestPosibleBookings(){   
                var vm = this;
                let current_date = new Date(); 
                let local_date = current_date.toISOString().substr(0, 10) 
                let current_datetime = null
                if (vm.date.toISOString().substr(0, 10) === this.current_datetime().substring(0,this.current_datetime().lastIndexOf(' ')) ){
                  let f = current_date.toISOString();
                  current_datetime = f.substring(f.indexOf('T') + 1,f.indexOf('T') + 6);  
                }
                try{
                    vm.$http.get('app/bookings/reservations_available', {
                        headers: {
                            "X-Device-ID" : this.getDeviceId(),
                            "Authorization" : 'Bearer ' + this.getUserToken()
                        },
                        params:{sublocation_id: vm.sublocation,
                            date: vm.date.toISOString().substr(0, 10),
                            current_date: current_date.toISOString(), 
                            current_datetime: current_datetime,
                            day: vm.days[vm.date.getDay()]  
                            }
                    }).then(function(response){
                    
                    vm.schedules=response.body.schedule
                    vm.sublocationSpaces=response.body.sublocation_spaces
                    vm.sublocationTime=response.body.sublocation_time
                    vm.location_time_zone = response.body.time_zone
                    vm.time_zone=response.body.time_zone.substring(response.body.time_zone.indexOf('/') + 1,response.body.time_zone.length).replace(/[_]/g, ' ')
                    vm.country=response.body.country
                    vm.gtm=response.body.gtm.replace(/[0]/g,'') 
                    for (let i = 0; i < vm.schedules.length; i++){
                      vm.styles.push({ style_height: 70 , click: false })
                    }
                    
                    if(response.body.meta != undefined && response.body.meta != null){
                      if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        this.checkToken(response.body.meta.authentication_token)
                      }
                    }
                  }, function(response){
                    if(response.body.meta != undefined && response.body.meta != null){
                      if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        this.checkToken(response.body.meta.authentication_token)
                      } 
                    }
                    /* console.log("=====Response=====");
                    console.log("Respuesta error de reservas"); */
                    if (response.status==401) { 
                      // alert(response.body.errors[0].details, "Un momento...");
                      this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                      this.updateIsInAlert(true)
                    }else{
                      this.updateAlertMessage(response.body.errors[0].details);
                      this.updateIsInAlert(true)
                    }
                  });
                }catch(e){
                  console.log("Fallo reservas home");
                  this.updateAlertMessage(e.message);
                  this.updateIsInAlert(true)
                }

                vm.is_changed = false; 
            },
            convertHourToStyleFormat(hour){
              var arr=hour.split(":")
              var amOrPm="am"
              if(arr[0]>=12){        
                amOrPm="pm"
                if(arr[0]>12){
                  arr[0]= Number(arr[0])%12
                }
              }else if(arr[0]==0){
                arr[0]=12
              }
              if(Number(arr[0])<10){
                arr[0]="0"+Number(arr[0]).toString() 
              }
              return arr[0]+":"+arr[1]+" "+amOrPm;
            },
            clickBooking(schedule_beginning,schedule_ending,index){
            var vm = this;
            this.$emit('selected',
                        { start_time: schedule_beginning,
                          end_time: schedule_ending,
                          index: index, 
                        }) 
            },
            convertTimeToString(hh){
              let hour = String(hh)
              let h = hour.substring(0,hour.indexOf(':'))
              let m = hour.substring(hour.indexOf(':') + 1,hour.length)
              return h + " h " + m + " m"
            },
            current_datetime: function(){
              let date = new Date();
              let dateStr =
                date.getFullYear() + "-" +
                ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
                ("00" + date.getDate()).slice(-2) + " " +
                ("00" + date.getHours()).slice(-2) + ":" +
                ("00" + date.getMinutes()).slice(-2) + ":" +
                ("00" + date.getSeconds()).slice(-2);
                return dateStr
            },
        },/* Close methods */
        mounted(){
            var vm = this;                      
            this.requestPosibleBookings();
            this.schedules.push({start_hour:"08:00 a.m",
                            end_hour:"09:00 a.m.",
                            sesion:"1",
                            spaces_available:100})
            this.schedules.push({start_hour:"09:00 a.m",
                            end_hour:"10:00 a.m.",
                            sesion:"1",
                            spaces_available:99})
            this.schedules.push({start_hour:"10:00 a.m",
                            end_hour:"11:00 a.m.",
                            sesion:"1",
                            spaces_available:80})
        },
        filters:{
            spanishDate(value){                
                var myTime=value.getDay();                            
                var weekday=null
                if(!isNaN(myTime)){ 
                    weekday=['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][myTime];
                }
                var month="Mes"                
                if(!isNaN(value.getMonth())){
                    month=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"][value.getMonth()]
                }
                return weekday + " " + value.getDate() + " de " + month
            }
        },
        computed:{
          timeZoneLocal: function(){
            let resolvedOptions = Intl.DateTimeFormat().resolvedOptions()
            return resolvedOptions.timeZone
          }
        }   
    }
</script>



// WEBPACK FOOTER //
// src/components/views/bookings/TimeSelect.vue